/* eslint-disable import/no-default-export */
import { createReducer } from 'app/gamma/src/util/reducers';

export interface ShortLinkMapState {
  [id: string]: string;
}

const initialState: ShortLinkMapState = {};

export default createReducer(initialState, {});
